import {FC, useEffect} from 'react';

interface IProps {
    name: any,
    content: any,
    [key: string]: any,
}

export const MetaTags: FC<IProps> = ({name, content}) => {
    useEffect(() => {
        if (name && content) {
            document.getElementsByTagName('meta')[name].content = content;
        }

        return () => {
            document.getElementsByTagName('meta')['description'].content = 'Digital Service Portal';
        };
    }, [name, content]);

    return null;
}